"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _actions = _interopRequireDefault(require("../../../../elements/other/actions"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _chartCommon = require("../common/chart-common");
var _text = _interopRequireDefault(require("@ux/text"));
/**
 * Local Imports
 */

const PriceContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PriceContainer",
  class: "pl-p12cilqy"
});
const ButtonWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonWrapper",
  class: "pl-bf9eq5h"
});

/**
 * FootColumn Component.
 *
 * @param {Object} props React props
 * @param {String} props.packageName Package name
 * @param {Object} props.price Price Lockup items
 * @param {Array} props.ctas CTA Items
 * @param {String} props.disclaimer Disclaimer text
 * @returns {React.ReactElement} FootColumn Component
 * @public
 */

function FootColumn({
  packageName,
  price,
  ctas,
  disclaimer
}) {
  return /*#__PURE__*/_react.default.createElement(PriceContainer, null, packageName && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -2,
    text: packageName,
    "data-cy": "package-name"
  }), price && /*#__PURE__*/_react.default.createElement(_price.default, (0, _extends2.default)({}, price, {
    headlineSize: "h5"
  })), ctas?.length > 0 && /*#__PURE__*/_react.default.createElement(ButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: ctas
  })), disclaimer && /*#__PURE__*/_react.default.createElement(_chartCommon.DisclaimerItem, {
    text: disclaimer
  }));
}
var _default = exports.default = FootColumn;
FootColumn.propTypes = {
  packageName: _propTypes.default.string,
  price: _propTypes.default.shape(_price.default.propTypes),
  ctas: _propTypes.default.arrayOf(_propTypes.default.shape(_merchButton.NSMerchButton.propTypes)),
  disclaimer: _propTypes.default.string
};